var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { GemElement } from '../../lib/element';
import { attribute } from '../../lib/decorators';
/**
 * 直接写会被解释成固定属性，需要使用变量赋值
 *
 * @attr content
 * @attr contentcss
 */
export class GemUnsafeElement extends GemElement {
    constructor() {
        super();
        this.effect(() => {
            if (this.shadowRoot) {
                this.shadowRoot.innerHTML = `
            <style>
              :host {
                display: contents;
              }
              ${this.contentcss}
            </style>
            ${this.content}
          `;
            }
        }, () => [this.content, this.contentcss]);
    }
    render() {
        return undefined;
    }
}
__decorate([
    attribute
], GemUnsafeElement.prototype, "content", void 0);
__decorate([
    attribute
], GemUnsafeElement.prototype, "contentcss", void 0);
//# sourceMappingURL=unsafe.js.map